import { lazy } from 'react';

const IncomingInvoices = lazy(() => import('./IncomingInvoices'));

export default IncomingInvoices;
